import React from 'react'

import { Box, Icon, Tooltip } from '@driftt/dds'

import { ActivityType } from 'modules/accountActivity/domain'
import { getActivityEventIconAndColor } from 'utils/activity'

export const ActivityIcon = ({ activityType }: { activityType: ActivityType }) => {
  const { icon, color, tooltip } = getActivityEventIconAndColor(activityType)

  return (
    <Tooltip content={tooltip} side="top">
      <Box css={{ padding: '4px 5px', backgroundColor: color, borderRadius: '32px' }}>
        <Icon size="medium" icon={icon} color="white" />
      </Box>
    </Tooltip>
  )
}
